import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Thequipment from '../entities/thequipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface ThequipmentState extends ListState<Thequipment>{
    editThequipment:Thequipment,
    analyseThequipment: Thequipment
}
class UserMutations extends ListMutations<Thequipment>{

}
class ThequipmentModule extends ListModule<ThequipmentState,any,Thequipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Thequipment>(),
        loading:false,
        editThequipment:new Thequipment()
    }
    actions={
        async getPage(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async getDataforExcel(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            return page.items;
        },
        async getscreenThe(context:ActionContext<ThequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetScreenThe',{params:payload.data});
            return reponse.data.result;
        },
        async getCountHome(context:ActionContext<ThequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetCountHome');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            return page;
        },
        async getCountHomeEchart(context:ActionContext<ThequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetCountHomeEchart');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            return page;
        },
        async GetRealPaged(context:ActionContext<ThequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetRealPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async GetGlobalPaged(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetGlobalPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getAll(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getEquList(context:ActionContext<ThequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetEquList',{params:payload.data});
            return reponse.data.result;
        },
        async create(context:ActionContext<ThequipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/ThEquipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<ThequipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/ThEquipment/Update',payload.data);
        },
        async delete(context:ActionContext<ThequipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThEquipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ThequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetById?Id='+payload.id);
            return reponse.data.result as Thequipment;
        },
        async getLngLat(context:ActionContext<ThequipmentState,any>){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetLngLat');
            return reponse.data.result;
        },
        ///获取所有设备数量
        async getAllEquCount(context:ActionContext<ThequipmentState,any>){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetAllEquCount');
            return reponse.data.result;
        },
        ///获取设备数量
        async getCount(context:ActionContext<ThequipmentState,any>,payload:any){
            //console.log(payload);
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetCount?status='+payload.data.status);
            return reponse.data.result.count;
        },
        //通过mac获取设备
        async getPageBymac(context:ActionContext<ThequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThEquipment/GetPaged',{params:payload.data});
            return reponse.data.result.items as Thequipment;
        }
    };
    mutations={
        setCurrentPage(state:ThequipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ThequipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: ThequipmentState, thequipment: Thequipment) {
            state.analyseThequipment = thequipment;
        },
        edit(state:ThequipmentState,thequipment:Thequipment){
            
            state.editThequipment=thequipment;
            //console.log(state.editFloor);
        }
    }
}
const thequipmentModule=new ThequipmentModule();
export default thequipmentModule;